














import { Component, Vue, Watch } from "vue-property-decorator";
import CalculationForm from "./CalculationForm.vue";
import CalculationResult from "./CalculationResult.vue";
import IssueForm from "./IssueForm.vue";
import IssueResult from "./IssueResult.vue";

import { TravelCalculateForm, TravelCalculateResult, TravelIssueResult } from "@/types/all";

@Component({
  components: { CalculationForm, CalculationResult, IssueForm, IssueResult }
})
export default class TravelForm extends Vue {
  public state: number = 0;
  public calculationForm: TravelCalculateForm = {} as TravelCalculateForm;
  public calculationResult: TravelCalculateResult = {} as TravelCalculateResult;
  public issueResult: Array<TravelIssueResult> = [];

  public onCalculatedHandler(calculationForm: TravelCalculateForm, calculationResult: TravelCalculateResult): void {
    this.calculationForm = calculationForm;
    this.calculationResult = calculationResult;

    this.state = 1;
  }

  public onNextHandler(): void {
    this.state += 1;
  }

  public onGoBackHandler(): void {
    this.state -= 1;
  }

  public onIssuedHandler(data: Array<TravelIssueResult>): void {
    console.log(data);

    this.issueResult = data;

    this.state = 3;
  }

  @Watch("form.period")
  onPropertyChanged(value: number, oldValue: number) {
    if (value) {
      alert(value);
    }
  }
}
